<style lang="less" scoped>
@import "index.less";
</style>

<template>
  <div>
    <!--过滤条件区域-->
    <div class="filter">
      <div class="filter-row" v-if="secondCates.length > 0">
        <div class="filter-field">
          系列：
        </div>
        <div class="filter-value">
          <el-checkbox-group v-model="myFilter.secondCates" @change="this.handleChange" class="filter-checkbox-group">
            <el-checkbox v-for="cate in secondCates" :label="String(cate.id)" :value="cate.id">
              {{cate.cateName}}
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-field">
          筛选：
        </div>
        <div class="filter-value">
          <el-checkbox-group class="filter-checkbox-group" v-model="myFilter.marks" @change="handleChange">
            <el-checkbox v-for="mark in $enums.productMark.getList()" :label="mark.value">{{mark.label}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-field">
          排序：
        </div>
        <div class="filter-value">
          价格 <svg-icon class="filter-icon"
                       :icon-class="mySort.price ? `sort-${mySort.price}` : 'sort'"
                       @click.native="handlePriceSort"
        />
        </div>
      </div>
    </div>

    <div class="product-list">
      <el-row :gutter="10">
        <el-col :span="6" v-for="(product,index) in collection" :key="index">
          <div class="product-box">
            <album class="product-album" v-model="selectedSpecIdsByProduct[index]" :images="getAlbumImage(index)" />
            <div class="product-info">
              <div class="product-name ellipsis">{{getProductSpecName(index)}}</div>
              <div class="product-market-price">{{getProductSpecPrice(index) | price}}</div>
              <div>
                <router-link :to="getActivityProductLink(index)">
                  <span class="product-price">{{getActivityProductPrice(index) | price}}</span>
                </router-link>
                <span @click="addCart(index)">
                     <svg-icon class="product-cart-icon" :icon-class="getActivityProductStock(index) > 0 ? 'cart-circle' : 'cart-circle-disabled'"/>
                </span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <div class="pagination">
        <pagination :total="total" :pagination="pagination" :changed="handlePageChange" />
      </div>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex'
import { isSellOut } from "@/helpers";
import _ from 'lodash'

const { mapState: cateMapState, mapGetters: cateMapGetters } = createNamespacedHelpers('activityCate')
const { mapState: productsMapState } = createNamespacedHelpers('products')
const sallOutImagePath = require('@/assets/watermark/sell-out.png')
import CartOperator from '@/mixins/CartOperator'

export default {
  mixins: [CartOperator],
  props: {
    filter: {
      type: Object
    },
    sort: {
      type: Object
    },
    currentPage: {
      type: Number
    },
    secondCates: {
      type: Array,
      default: () => []
    }
  },
  data: function () {
    return {
      selectedSpecIdsByProduct: [],
      myFilter: {
        cateId: 0,
        secondCates: [],
        hasStock: false,
        keyword: '',
        marks: [] // 可选值 'new'
      },
      mySort: {
        price: '' // 可选值'', 'asc', 'desc'
      },
      myCurrentPage: 1
    }
  },
  computed: {
    ...productsMapState([
      'collection',
      'pagination',
      'total'
    ])
  },
  methods: {
    async queryProducts() {
      const query = {
        topCateId: this.myFilter.cateId,
        cateIds: this.myFilter.secondCates,
        marks: this.myFilter.marks,
        keyword: this.myFilter.keyword,
        showHasStock: this.myFilter.hasStock ? 1 : 0,
      }
      const sorts = this.sort
      const pagination = { limit: 16, currentPage: this.myCurrentPage }
      this.$store.dispatch('products/collection', {query, sorts, pagination})
    },
    //添加购物车
    addCart(productIndex) {
      const product = this.collection[productIndex];
      const spec = this.getSelectedSpec(productIndex);
      let productInfo = spec.activityProducts[0];
      productInfo.productSpec = spec;
      productInfo.product = product

      const cart = { productInfo, num : 1};
      this.addToCart(cart)
    },
    handleChange() {
      this.resetCurrentPage()
      this.submitQuery()
    },
    handlePageChange({pagination}) {
      this.myCurrentPage = pagination.currentPage
      this.submitQuery()
    },
    handlePriceSort() {
      let sort = ''
      switch (this.mySort.price) {
        case '':
          sort = 'asc'
          break
        case 'asc':
          sort = 'desc'
          break
        case 'desc':
          sort = ''
          break
      }
      this.mySort.price = sort
      this.resetCurrentPage()
      this.submitQuery()
    },
    resetCurrentPage() {
      this.myCurrentPage = 1
    },
    submitQuery(){
      this.$emit('change', {
        filter: this.myFilter,
        sort: this.mySort,
        currentPage: this.myCurrentPage,
      })
    },

    getProductSpecName(productIndex) {
      const spec = this.getSelectedSpec(productIndex)
      return spec ? spec.specName : ''
    },
    getProductSpecPrice(productIndex) {
      const spec = this.getSelectedSpec(productIndex)
      return spec ? spec.price : ''
    },
    getActivityProductPrice(productIndex) {
      const spec = this.getSelectedSpec(productIndex)
      return spec ? spec.activityProducts[0].price : ''
    },
    getActivityProductStock(productIndex) {
      const spec = this.getSelectedSpec(productIndex)
      return spec ? parseInt(spec.activityProducts[0].stock) : 0
    },
    getAlbumImage(productIndex) {
      let images = []
      const productSpecs = this.collection[productIndex].productSpecs
      productSpecs.forEach(spec => {
        const tag = spec.activityProducts[0].mark
        const img = spec.photos.length > 0 ? spec.photos[0].url: '';
        images.push({
          title: spec.specName,
          img: img,
          link: this.getActivityProductLink(productIndex),
          watermark : isSellOut(spec.activityProducts[0]),
          watermarkImage : isSellOut(spec.activityProducts[0]) ? sallOutImagePath : '',
          tag
        })
      })
      return images
    },
    getSelectedSpec(productIndex) {
      const specIndex = this.selectedSpecIdsByProduct[productIndex]
      if (typeof specIndex != 'undefined') {
        return this.collection[productIndex].productSpecs[specIndex]
      } else {
        return null
      }
    },
    getActivityProductLink(productIndex) {
      const spec = this.getSelectedSpec(productIndex)
      return spec ? {
        name: 'product-detail',
        params: {
          id: spec.activityProducts[0].id
        }
      } : {}
    },
    isPropNotAccept(value){
      return value == null || (typeof value === 'undefined')
    },
    dealObjectProp(prop){
      const _prop = _.cloneDeep(prop)
      _.forEach(_prop, (value, key) => {
        if (this.isPropNotAccept(value)) {
          delete _prop[key]
        }
      })
      return _prop
    }
  },
  watch: {
    filter(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        this.selectedSpecIdsByProduct = this.selectedSpecIdsByProduct.map(() => 0)
        //console.log('watch filter')
        this.myFilter = { ...this.myFilter, ...this.dealObjectProp(newValue)}
        this.queryProducts()
      }
    },
    sort(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        //console.log('watch sort')
        this.mySort = { ...this.mySort, ...this.dealObjectProp(newValue.sort) }
        this.queryProducts()
      }
    },
    currentPage(newValue, oldValue){
      if (!_.isEqual(newValue, oldValue)) {
        //console.log('watch currentPage')
        this.myCurrentPage = newValue
        this.queryProducts()
      }
    }
  },
  mounted() {
    this.myFilter = { ...this.myFilter, ...this.dealObjectProp(this.filter) }
    this.myCurrentPage = this.currentPage
    this.mySort = { ...this.mySort, ...this.dealObjectProp(this.sort) }
    this.queryProducts()
  }
}
</script>
